<template>
  <el-dialog
    :title="$t('api.actions.createNote.dialog.title')"
    :visible.sync="visible"
    custom-class="rwd-dialog-large"
  >
    <el-form
      :model="formData"
      label-position="top"
      v-loading="loading"
      ref="formData"
    >
      <el-row :gutter="20">
        <el-col :xs="24">
          <remote-opt
            v-model="invoiceData.doc_id"
            :base="base"
            name="invoice_number"
            :labelArr="['number']"
            :fetchList="fetchInvoiceList"
            :srchFilter="invoiceSrchFilter"
            :isAutoFetch="false"
            :isNeedQuery="true"
            keyName="doc_id"
            valueName="doc_id"
            @change="onChangeInvoice"
            sort="doc_id"
            required
          >
          </remote-opt>
        </el-col>
      </el-row>
      <el-tabs
        class="dialog-tabs"
        v-model="activeTab"
        v-if="invoiceData && branchData"
      >
        <el-tab-pane
          :label="getLabelText('actions.createNote.byEditBookings.tabs', 'coverFees')"
          name="coverFees"
        >
          <cover-fees-tab
            :base="base"
            :formData="formData"
            :invoiceData="invoiceData"
            :branchData="branchData"
            @change="onChangeEditList"
            ref="coverFeesTab"
          >
          </cover-fees-tab>
        </el-tab-pane>
      </el-tabs>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button
        @click="visible = false"
      >
        {{ $t('api.cancelBtn') }}
      </el-button>
      <el-button type="primary"
        @click="save"
        :loading="saveLoading"
        :disabled="formData.edit_list.length === 0"
      >
        {{ $t('api.saveBtn') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import CoverFeesTab from './CoverFeesTab'
import { createByEditBookings as create } from '@/api/chart/soa/note'
import {
  fetchOne as fetchInvoice,
  fetchList as fetchInvoiceList
} from '@/api/chart/soa/invoice'
import { fetchOne as fetchBranch } from '@/api/merchant/branch'
import { transText, getLabelText } from '@/utils/i18n'
import { SOADocumentDueDateType } from '@/enums'

const defFormData = {
  invoice_doc_id: undefined,
  bid: undefined,
  date: '',
  due_date_type: SOADocumentDueDateType.None,
  edit_list: []
}

export default {
  name: 'note-by-edit-bookings-dialog',
  components: {
    CoverFeesTab
  },
  data () {
    return {
      base: 'note',
      formData: Object.assign({}, defFormData),
      invoiceData: {
        doc_id: undefined
      },
      branchData: null,
      invoiceSrchFilter: '{$and:[{invoice_type:0},{number:"%`value`%"},{status:0}]}',
      activeTab: 'coverFees',
      saveLoading: false,
      loading: false,
      visible: false
    }
  },
  props: {
    afterSaveOK: {
      type: Function,
      default: () => {}
    }
  },
  methods: {
    create,
    fetchInvoice,
    fetchInvoiceList,
    fetchBranch,
    transText,
    getLabelText,
    reset () {
      this.formData = Object.assign({}, defFormData)
      this.formData.date = this.$moment().format('YYYY-MM-DD')
      this.invoiceData = {doc_id: undefined}
      this.branchData = null
      if (this.$refs.coverFeesTab) {
        this.$refs.coverFeesTab.reset()
      }
    },
    show () {
      this.visible = true
    },
    hide () {
      this.visible = false
    },
    save () {
      this.saveLoading = true
      this.$refs.formData.validate(valid => {
        if (!valid) {
          this.saveLoading = false
          return
        }

        this.create(this.formData).then(() => {
          this.$message({
            message: this.transText(this.base + '.addSuccess'),
            type: 'success',
            duration: 2000
          })
          this.hide()
          this.reset()
          this.afterSaveOK()
        }).catch((err) => {
          console.log(err)
        }).then(() => {
          this.saveLoading = false
        })
      })
    },
    onChangeInvoice (docID) {
      this.reset()
      this.getInvoiceData(docID).then(() => {
        this.getBranchData(this.invoiceData.bid)
      })
    },
    async getInvoiceData (docID) {
      this.loading = true
      try {
        let res = await this.fetchInvoice(docID)
        this.invoiceData = res.data
        this.formData.invoice_doc_id = this.invoiceData.doc_id
      } catch (error) {
        console.log(error)
      }
      this.loading = false
    },
    async getBranchData (bid) {
      this.loading = true
      try {
        let res = await this.fetchBranch(bid)
        this.branchData = res.data
        this.formData.bid = this.branchData.bid
      } catch (error) {
        console.log(error)
      }
      this.loading = false
    },
    onChangeEditList (payload) {
      this.formData.edit_list = payload.editList
    }
  },
  created () {
    this.reset()
  }
}

</script>
